"use client"

import type { FeedTab } from "@/lib/community/types"

const FEED_TABS: { key: FeedTab; label: string }[] = [
  { key: "recommended", label: "推荐" },
  { key: "latest", label: "最新" },
  { key: "following", label: "关注" },
  { key: "hot", label: "热榜" },
]

/**
 * CommunityTabs — minimal underline-style tab bar.
 * Matches the emerald accent of the app's design system.
 */
export function CommunityTabs({
  active,
  onChange,
}: {
  active: FeedTab
  onChange: (tab: FeedTab) => void
}) {
  return (
    <div className="flex items-center gap-1">
      {FEED_TABS.map((tab) => (
        <button
          key={tab.key}
          type="button"
          onClick={() => onChange(tab.key)}
          className={`relative px-3 py-1.5 text-sm font-medium transition-colors duration-200 rounded-md ${
            active === tab.key
              ? "text-foreground"
              : "text-muted-foreground hover:text-foreground/80"
          }`}
        >
          {tab.label}
          {active === tab.key && (
            <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-4 h-0.5 rounded-full bg-primary" />
          )}
        </button>
      ))}
    </div>
  )
}
